import React from 'react'
import { NavLink } from 'react-router-dom';

import './Tabs.css';

function Tabs({tabs}) {
  return (
    <nav className='tabs'>
      <ul className='items'>
        {
            tabs.map((tab,index)=>{
              const navLinkProps = {
                activeclassname: "selected",
                to: tab.link 
              };
              return(
                <li key={index}><NavLink {...navLinkProps}>{tab.title}</NavLink></li>
              )
            })
        }
      </ul>
      <hr className='hr'/>
    </nav>
  )
}

export default Tabs;
